"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PossessionsUtils = void 0;
const possessions_1 = require("./possessions");
class PossessionsUtils {
    static getVersionPossessionLevels(params) {
        const { version, possession } = params;
        const versionPossessions = possessions_1.versionsPossessionsLevels[version];
        if (versionPossessions) {
            return versionPossessions[possession];
        }
    }
    static getVersionPossessionLevelLabel(params) {
        const { version, possession, level } = params;
        const possessionLevels = PossessionsUtils.getVersionPossessionLevels({
            version,
            possession,
        });
        if (possessionLevels) {
            return possessionLevels[level];
        }
    }
}
exports.PossessionsUtils = PossessionsUtils;
